import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { environment } from 'src/environments/environment';
import { ServerResponse } from 'src/app/core/interfaces/server.interface';
import { PaginationOptions } from 'src/app/core/interfaces/pagination-options';
import { Branch } from '../interfaces/branch.interface';
import { $t } from '@primeng/themes';


const baseUrl = environment.baseUrl;

@Injectable({
    providedIn: 'root'
})
export class BranchesService {

    private http = inject(HttpClient);

    getBranches(options: PaginationOptions): Observable<ServerResponse> {

        const { per_page = 10, page } = options;

        const params: any = { per_page };

        if (page !== undefined) params.page = page;

        return this.http.get<ServerResponse>(`${baseUrl}${API_ENDPOINTS.GET_BRANCHES}`, { params })
    }

    syncBranches(): Observable<ServerResponse> {
        return this.http.post<ServerResponse>(`${baseUrl}${API_ENDPOINTS.SYNC_BRANCHES}`, {})
    }

    getCatalog(): Observable<{ data: Branch[] }> {
        const params: any = { scope: 'user' };
        return this.http.get<{ data: Branch[] }>(`${baseUrl}${API_ENDPOINTS.CATALOG_BRANCHES}`, { params });
    }
}
